module.exports = __webpack_public_path__ + "1425f5811db672284fd723f1a494f329.fbx";